import "../scss/screen.scss";

// Import modules
// import { initContactFormLabels } from "./modules/contact-form-labels.js";
// import initCoverVideo from "./modules/conditional-video-loader.js";
// import CoreCompatibleMobileSubmenuFix from "./modules/mobile-submenu-fix.js";
//import initHeadroom from "./modules/headroom-init.js";
//import initLogoSlider from "./modules/logo-slider.js";
//import initCopyLink from "./modules/copy-link.js";
//import initVideoOverlay from "./modules/custom-play-button.js";

// Initialize headroom (runs immediately)
//initHeadroom();

// Initialize modules that auto-init on load
// const coverAPI = initCoverVideo();
//const cfLabels = initContactFormLabels();

// Initialize modules on DOM ready
document.addEventListener("DOMContentLoaded", () => {
  // new CoreCompatibleMobileSubmenuFix();
  //initLogoSlider();
  //initCopyLink();
  //initVideoOverlay();
});
